module.exports = __webpack_public_path__ + "static/media/level5_flag.aa3e0932.svg";